module.exports = __webpack_public_path__ + "cl.svg?57d4c24c75a6cf84bdb128739b318555";